/* eslint-disable react/jsx-no-comment-textnodes */
import type { ReactNode, ReactElement } from 'react';

// @mui
import { Button } from '@mui/material';
// components
import { Icon as Iconify } from '@iconify/react';

export interface ChatRoomCollapseButtonProps {
  sx?: Record<string, any>;
  children?: ReactNode;
  isCollapse?: boolean;
  onCollapse?: (...args: any[]) => any;
  [key: string]: any;
}

// ----------------------------------------------------------------------

export default function ChatRoomCollapseButton({
  isCollapse,
  onCollapse,
  children,
  sx,
  ...other
}: ChatRoomCollapseButtonProps) {
  return (
    <Button
      fullWidth
      color="inherit"
      onClick={onCollapse}
      endIcon={
        <Iconify
          width={16}
          // @ts-ignore legacy boundary
          icon={
            isCollapse
              ? 'eva:arrow-ios-downward-fill'
              : 'eva:arrow-ios-forward-fill'
          }
        />
      }
      sx={{
        height: 40,
        flexShrink: 0,
        borderRadius: 0,
        typography: 'overline',
        color: 'text.disabled',
        justifyContent: 'space-between',
        p: (theme) => theme.spacing(1, 1.5, 1, 2.5),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Button>
  );
}
